import { render, staticRenderFns } from "./FacebookPageCard.vue?vue&type=template&id=db5ef3fc&scoped=true&"
import script from "./FacebookPageCard.vue?vue&type=script&lang=ts&"
export * from "./FacebookPageCard.vue?vue&type=script&lang=ts&"
import style0 from "./FacebookPageCard.vue?vue&type=style&index=0&id=db5ef3fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db5ef3fc",
  null
  
)

export default component.exports